import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("Asia/Bangkok");

/**
 * Parses a date from the database and converts it to the 'Asia/Bangkok' timezone.
 * If the input date string is empty or undefined, the current date is used.
 *
 * @param dateString - The date string from the database in UTC format (optional).
 * @param formatDate - The desired output date format (default: 'YYYY-MM-DD HH:mm:ss').
 * @returns The formatted date string in 'Asia/Bangkok' timezone.
 *
 * @example
 * const dbDate = "2025-03-05T12:00:00Z";
 * const parsedDate = parseDateFromDb(dbDate);
 * console.log('Parsed Date (Bangkok Time):', parsedDate);
 */
export const parseDateFromDb = (
  dateString: string,
  formatDate: string = "YYYY-MM-DD HH:mm:ss",
): String => {
  const convertDate = dayjs
    .utc(dateString || dayjs().toISOString())
    .tz("Asia/Bangkok")
    .format(formatDate);
  return convertDate;
};

/**
 * Formats a dayjs date object to a UTC date string for saving to the database.
 *
 * @param date - The dayjs date object to format.
 * @returns The formatted UTC date string.
 *
 * @example
 * const parsedDate = dayjs();
 * const formattedDate = formatDateToDb(parsedDate);
 * console.log('Formatted Date for Database (UTC):', formattedDate);
 */
export const formatDateToDb = (date: dayjs.Dayjs): string => {
  return date.utc().format();
};

/**
 * Formats a date string in 'YYYY-MM-DD HH:mm:ss' format to a UTC date string for saving to the database.
 *
 * @param dateString - The date string to format (in 'YYYY-MM-DD HH:mm:ss' format).
 * @returns The formatted UTC date string.
 *
 * @example
 * const dateString = '2025-03-05 19:00:00';
 * const formattedDate = formatDateForDatabase(dateString);
 * console.log('Formatted Date for Database (UTC):', formattedDate);
 */
// export const formatDateForDatabase = (dateString: string): string => {
//   const date = dayjs.tz(dateString, "YYYY-MM-DD HH:mm:ss", "Asia/Bangkok");
//   return date.utc().format();
// };
